// extracted by mini-css-extract-plugin
export default {"default":"kL6g1CGc"};